module.exports = __webpack_public_path__ + "static/atlanta-ae447506b70ff7b828c2389ce458e8ff.png";